import { api } from '../../lib/api';

export interface EnrollmentStart {
  secret: string;
  qrCodeDataUrl: string;
}

export function startEnrollment(password?: string): Promise<EnrollmentStart> {
  return api<EnrollmentStart>('/auth/totp/enroll', { method: 'POST', body: JSON.stringify({ password }) });
}

export function confirmEnrollment(code: string): Promise<{ recoveryCodes: string[] }> {
  return api<{ recoveryCodes: string[] }>('/auth/totp/enroll/verify', { method: 'POST', body: JSON.stringify({ code }) });
}

export function disableTotp(password: string): Promise<void> {
  return api<void>('/auth/totp/disable', { method: 'POST', body: JSON.stringify({ password }) });
}
